export default __webpack_public_path__ + "static/media/fantom-logo.40755d1e.png";